<template>
	<!-- Main-Slider -->
	<ContentLoader
		viewBox="0 0 500 170"
		primaryColor="#BABABA"
		class="shadow"
		v-if="getStatus.home_page_slider_images.loading"
	>
		<rect x="0" y="0" rx="0" ry="0" width="500" height="170" />
	</ContentLoader>
	<swiper
		class="shadow-lg"
		:slides-per-view="1"
		:space-between="0"
		:navigation="true"
		:pagination="{clickable: true}"
		:loop="true"
		:autoplay="true"
		v-else
	>
		<swiper-slide
			v-for="(img, index) in getDashboard.home_page_slider_images"
			:key="index"
		>
			<div class="slider_image">
				<div class="overlay"></div>
				<img
					class="img-fluid"
					v-lazy="{
						src: getFullImagePath(img.image.path),
						loading: publicPath + 'assets/images/slider_loader.gif',
					}"
				/>
			</div>
			<div class="slide-content slide-animation">
				<strong
					><h1>{{ img.title }}</h1></strong
				>
				<h2>Start shopping</h2>
			</div>
		</swiper-slide>
	</swiper>
	<!-- Main-Slider /- -->
	<!-- Banner-Layer -->
	<div class="banner-layer">
		<div class="container">
			<div class="image-banner">
				<a href="shop-v1-root-category.html" class="mx-auto banner-hover">
					<img
						class="img-fluid rounded mx-auto d-block"
						src="assets/images/banners/Smart.gif"
						alt="Winter Season Banner"
						:style="{width: '600px'}"
					/>
				</a>
			</div>
		</div>
	</div>
	<!-- Banner-Layer /- -->
</template>

<script>
	import {mapActions, mapGetters} from "vuex";
	import {publicPath} from "../../../vue.config";
	import {ContentLoader} from "vue-content-loader";
	// import Swiper core and required components
	import SwiperCore, {Navigation, Pagination, A11y, Autoplay, Lazy} from "swiper";
	// Import Swiper Vue.js components
	import {Swiper, SwiperSlide} from "swiper/vue";
	// Import Swiper styles
	import "swiper/swiper.scss";
	import "swiper/components/navigation/navigation.scss";
	import "swiper/components/pagination/pagination.scss";
	// install Swiper components
	SwiperCore.use([Navigation, Pagination, A11y, Autoplay, Lazy]);
	export default {
		components: {
			Swiper,
			SwiperSlide,
			ContentLoader,
		},
		computed: {
			...mapGetters("dashboard", ["getDashboard", "getStatus"]),
		},
		data() {
			return {
				loading: true,
				imgData: [],
				publicPath: publicPath,
			};
		},
		methods: {
			...mapActions("dashboard", ["fetchHomePageSliderImages"]),
			getFullImagePath(path) {
				return process.env.VUE_APP_API_URL + path;
			},
		},
		mounted() {
			if (this.getDashboard.home_page_slider_images.length == 0) {
				this.fetchHomePageSliderImages();
			}
			this.imgData = [
				{
					picture:
						process.env.VUE_APP_ROOT_URL + "/assets/images/main-slider/slide1.jpeg",
					title: "Home automation control and precise power monitoring",
				},
				{
					picture:
						process.env.VUE_APP_ROOT_URL + "/assets/images/main-slider/slide2.jpeg",
					title: "Works with Alexa, Google Home, Android and iOS",
				},
				{
					picture:
						process.env.VUE_APP_ROOT_URL + "/assets/images/main-slider/slide3.jpeg",
					title: "Save energy and control appliance remotely",
				},
			];
		},
	};
</script>

<style>
	img[lazy="loading"] {
		object-fit: none !important;
	}
	.slider_image img {
		object-fit: cover;
		width: 100%;
		height: 500px;
	}
	.overlay {
		position: absolute;
		background-color: rgba(0, 0, 0, 0.3);
		height: 100%;
		width: 100%;
	}
	.slide-content h2 {
		border: 1px solid white;
		width: max-content;
		padding: 10px;
		cursor: pointer;
		margin: auto;
		border-radius: 5px;
		transition: all 0.3s ease-in;
	}
	.slide-content h2:hover {
		background-color: white;
		color: black;
	}
	.swiper-button-prev,
	.swiper-button-next {
		color: white;
		opacity: 0.3;
	}
	.swiper-pagination-bullet-active {
		background-color: white;
	}
</style>
